import React from 'react';
import { graphql } from 'gatsby';

import { Layout } from '../components';
import { GetIndexPageQuery } from '../../graphql-types';

import { IndexTemplateDiv } from './styles';

export default function IndexTemplate({
  data: { asciidoc },
}: {
  data: GetIndexPageQuery;
}) {
  return (
    <Layout banner={asciidoc.document} seo={{ title: asciidoc.document.main }}>
      <IndexTemplateDiv
        dangerouslySetInnerHTML={{ __html: asciidoc.html }}
      ></IndexTemplateDiv>
    </Layout>
  );
}

export const pageQuery = graphql`
  query GetIndexPage($id: String) {
    asciidoc(id: { eq: $id }) {
      id
      html
      document {
        main
        title
        subtitle
      }
    }
  }
`;
